import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RequestType, SupportRequestDto } from "../core";
import { SupportService } from "../services/support.service";
import notify from "devextreme/ui/notify";

@Component({
  selector: "brd-support",
  templateUrl: "./support.component.html",
  styleUrl: "./support.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportComponent {
  private readonly supportService = inject(SupportService);

  supportFormGroup = new FormGroup({
    requestType: new FormControl<RequestType>(null, Validators.required),
    description: new FormControl<string>("", Validators.required)
  });

  issueTypeOptions = [
    { value: RequestType.cloud, label: "Cloud or Infrastructural Issue" },
    { value: RequestType.demoAsset, label: "Demo Asset Bug or Feedback" }
  ];

  onSubmit(): void {
    if (this.supportFormGroup.valid) {
      const request = this.supportFormGroup.value as SupportRequestDto;
      this.supportService.sendSupportRequest(request).subscribe({
        next: () => {
          notify({
            message: "Support request sent successfully.",
            type: "success",
            displayTime: 5000,
            maxWidth: 500,
            position: "top center",
            closeOnClick: true
          });
          this.supportFormGroup.reset();
        }
      });
    }
  }
}
